export type ImageKitchenStage = 'upload' | 'graph1' | 'graph2' | 'model' | 'smeta';

export const OPEN_IMAGE_KITCHEN_WORKFLOW_EVENT = 'holzcom-open-image-kitchen-workflow';

export function openImageKitchenWorkflow(stage: ImageKitchenStage): void {
  window.dispatchEvent(new CustomEvent<ImageKitchenStage>(OPEN_IMAGE_KITCHEN_WORKFLOW_EVENT, { detail: stage }));
}
